<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container job-cust-select-modal">
          <div class="modal-header">
            <slot name="header">
              Round Summary
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body">
              <form class="col-12" @submit.prevent="handleSubmit">
                <div class="row">
                  <div class="col-1">
                    <label for="round">Round:</label>
                  </div>
                  <div class="col-4">
                    <label>{{ round_name }}</label>
                  </div>
                  <div class="col-1">
                    <label for="week">Week:</label>
                  </div>
                  <div class="col-4">
                    <label>Week {{ selected_week + 1 }}</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-1">
                    <label for="area">Area:</label>
                  </div>
                  <div class="col-4">
                    <label>{{ round_area }}</label>
                  </div>
                  <div class="col-1">
                    <label for="day">Day:</label>
                  </div>
                  <div class="col-4">
                    <label v-if="selected_day == 0">Monday</label>
                    <label v-if="selected_day == 1">Tuesday</label>
                    <label v-if="selected_day == 2">Wednesday</label>
                    <label v-if="selected_day == 3">Thursday</label>
                    <label v-if="selected_day == 4">Friday</label>
                    <label v-if="selected_day == 5">Saturday</label>
                    <label v-if="selected_day == 6">Sunday</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-1">
                    <label for="vehicle">Vehicle:</label>
                  </div>
                  <div class="col-4">
                    <label>{{ selected_vehicle_name }}</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">Assigned Customers:</div>
                  <div class="col-6">Assigned Personnels:</div>
                </div>
                <div class="row scroll-500">
                  <div class="col-6">
                    <draggable
                      class="h-min-200 h-100 p-0"
                      tag="ul"
                      v-model="schedule_round.round.jobs"
                      v-bind="dragOptions"
                      :move="onMove"
                      @start="isDragging = true"
                      @end="isDragging = false"
                    >
                      <transition-group name="no" class="d-block h-100">
                        <li
                          class="cust-select-item"
                          v-for="element in schedule_round.round.jobs"
                          :key="id + 'custs' + element.id"
                        >
                          <i
                            :class="
                              element.fixed
                                ? 'fa fa-anchor'
                                : 'glyphicon glyphicon-pushpin'
                            "
                            @click="element.fixed = !element.fixed"
                            aria-hidden="true"
                          ></i>
                          {{ element.description }}
                        </li>
                      </transition-group>
                    </draggable>
                  </div>
                  <div class="col-6">
                    <draggable
                      class="h-min-200 h-100 p-0"
                      tag="ul"
                      v-model="selected_personnel_list"
                      v-bind="dragOptions"
                      :move="onMove"
                      @start="isDragging = true"
                      @end="isDragging = false"
                    >
                      <transition-group name="no" class="d-block h-100">
                        <li
                          class="pers-select-item"
                          v-for="element in selected_personnel_list"
                          :key="id + 'pers' + element.id"
                        >
                          <i
                            :class="
                              element.fixed
                                ? 'fa fa-anchor'
                                : 'glyphicon glyphicon-pushpin'
                            "
                            @click="element.fixed = !element.fixed"
                            aria-hidden="true"
                          ></i>
                          {{ element.name }}
                        </li>
                      </transition-group>
                    </draggable>
                  </div>
                </div>
              </form>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-plt" @click="$emit('close')">
                Close without save
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import draggable from "vuedraggable";
import { mapState, mapActions } from "vuex";

export default {
  name: "CustomerSelection",
  props: {
    schedule_index: {
      type: Number,
      default: -1,
    },
    schedule_round: {
      type: Object,
      required: true,
    },
    week_index: {
      type: Number,
      default: -1,
    },
    day_index: {
      type: Number,
      default: -1,
    },
    copy_enabled: {
      type: Boolean,
      default: true,
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    submitted: false,
    personnel_list: [],
    selected_personnel_list: [],
    selected_week: -1,
    selected_day: -1,
    selected_vehicle_name: "",
    round_name: "",
    round_area: "",
    num_weeks: 0,
    tab: 1,
    id: -1,
  }),
  computed: {
    ...mapState("schedule", ["schedules", "schedule_group", "available_jobs"]),
    ...mapState("vehicles", ["vehicles"]),
    ...mapState("personnels", ["personnels"]),
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: true,
        ghostClass: "ghost",
      };
    },
  },
  mounted: function() {
    this.id = this._uid;
    this.$nextTick(function() {
      this.selected_week = this.schedule_round.week_index;
      this.selected_day = this.schedule_round.day_index;
      this.round_name = this.schedule_round.round.name;
      this.round_area = this.schedule_round.round.area;
      this.selected_vehicle_name = this.vehicles.find(
        x => x.id == this.schedule_round.vehicle_id,
      ).name;
      this.selected_personnel_list = this.schedule_round.personnels;
      if (this.schedule_index >= 0) {
        this.num_weeks = Number(this.schedules[this.schedule_index].duration);
      } else {
        this.num_weeks = this.schedule_group.duration;
      }

      if (!this.selected_personnel_list) {
        this.personnel_list = this.personnels.slice();
      } else {
        // remove all the personnel in the selected list from the available personnels
        var vm = this;
        this.personnel_list = this.personnels.filter(function(value) {
          var index = vm.selected_personnel_list.findIndex(
            v => v.id == value.id,
          );
          return index < 0;
        });
      }
    });
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    handleSubmit(e) {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          // submit data
        }
      });
    },
    ...mapActions("schedule", ["loadAvailableJobs", "moveScheduleRoundFrom"]),
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
    getName() {
      return this.schedule_round.round.name;
    },
    getArea() {
      return this.schedule_round.round.area;
    },
    getWeek() {
      if (this.week_index >= 0) {
        return this.week_index + 1;
      } else {
        return "";
      }
    },
  },
  watch: {
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    },
  },
  components: {
    draggable,
  },
};
</script>
